import React, { memo, PropsWithChildren } from 'react';

interface ContainerProps {
  className?: string;
  fullWidth?: boolean;
}

function Container(props: PropsWithChildren<ContainerProps>) {
  const { className = '', fullWidth = false, children } = props;
  return (
    <div
      className={[
        fullWidth ? 'w-full max-w-full' : 'max-w-7xl',
        'mx-auto px-4 sm:px-6 md:px-8 box-border',
        className,
      ].join(' ')}
    >
      {children}
    </div>
  );
}

export default memo(Container);
